import { useContext, useEffect } from "react";
import FullscreenLoadingSpinner from "./common/FullscreenLoadingSpinner";
import { AdminPortalLayout } from "./pages/AdminPortal/AdminPortalLayout";
import { SiteUserRole, UserContext, UserState } from "./userAccess/UserContext";

const UserRequired = ({ children, adminOnly }: { children: React.ReactNode, adminOnly: boolean }) => {
  const userStatus = useContext(UserContext);

  useEffect(() => {
    if (userStatus.state === UserState.SignedOut) {
      userStatus.signIn();
    }
  }, [userStatus]);

  if (userStatus.state === UserState.Loading) return <FullscreenLoadingSpinner />
  if (userStatus.state === UserState.SignedOut) return <></>;

  if (userStatus.userSites.length <= 0)
    return <AdminPortalLayout><h1>Please login as a site administrator to access the admin portal</h1></AdminPortalLayout>;

  if (!userStatus.selectedSite)
    return <AdminPortalLayout><h1>Please select a site</h1></AdminPortalLayout>;

  if (adminOnly && userStatus.selectedSite.role !== SiteUserRole.Admin)
    return <AdminPortalLayout><h1>You do not have permission to access this page</h1></AdminPortalLayout>;

  return <AdminPortalLayout>{children}</AdminPortalLayout>;
}

const SiteUserRequired: React.FC<{ children?: React.ReactNode }> = ({ children }) => 
  <UserRequired adminOnly={false}>{children}</UserRequired>

const AdminRequired: React.FC<{ children?: React.ReactNode }> = ({ children }) =>
  <UserRequired adminOnly={true}>{children}</UserRequired>

export { AdminRequired, SiteUserRequired };